import { Badge, type BadgeProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type DeletedBadgeProps = Omit<BadgeProps, 'children'> & {
  children: ReactNode;
};

export function DeletedBadge({ children, ...rest }: DeletedBadgeProps) {
  return (
    <Badge
      variant="outline"
      colorScheme="red"
      bg="bg.danger-subtle"
      borderRadius="full"
      px={2}
      textTransform="none"
      fontWeight="medium"
      {...rest}
    >
      {children}
    </Badge>
  );
}
